import { useContext, useId, useLayoutEffect } from 'react';
import { logger } from 'features/logger/logger';
import { LoadingOrchestratorContext } from './LoadingOrchestratorContext';

export const useReportLoading = (
  active: boolean,
  options?: { title?: string; description?: string }
): void => {
  const ctx = useContext(LoadingOrchestratorContext);
  const id = useId();
  const title = options?.title;
  const description = options?.description;

  useLayoutEffect(() => {
    if (!ctx || !active) return;
    return () => {
      ctx.unregister(id);
    };
  }, [ctx, active, id]);

  useLayoutEffect(() => {
    if (!active) return;
    if (!ctx) {
      logger.warn(
        'useReportLoading called outside LoadingOrchestratorProvider — loading state will not be reported'
      );
      return;
    }
    ctx.register({
      id,
      ...(title !== undefined && { title }),
      ...(description !== undefined && { description }),
    });
  }, [ctx, active, id, title, description]);
};
